module.exports = __webpack_public_path__ + "static/media/Callant.e388a638.png";